import { useCallback, useEffect, useState } from "react";
import { domain, token } from "../../../Security";
import axios from "../../../../api/apiClient";

import loadingSpinner from '../../../../assets/loading.gif';
import { CreateTableForEmployeeSelect } from "../TimeEntriesTables/CreateTableForEmployeeSelect";
import { CreateSearchBarWithPlaceHolder } from "../../../CommonObjects";

import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from '@mui/icons-material/Search';

export function EmployeeSelectForm({ isOpen,
  onClose,
  setEmployeeId,
  setEmployee,
  userAccessData
}) {
  var header = [
    "Id",
    "Name",
  ]
  var accessor = [
    "employeeId",
    "fullName"
  ]

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    setEmployeeId(selectedEmployee.id);
    setEmployee(selectedEmployee.fullName);
    fetchData();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [employeesInfo, setEmployeesInfo] = useState([]);
  const [allEmployeesBasicInfo, setAllEmployeesBasicInfo] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const [classificationFilterForAdminHRHead, setClassificationFilterForAdminHRHead] = useState("0");
  const [currentClassificationFilter, setCurrentClassificationFilter] = useState("");

  /* const fetchDataAllData = useCallback(async () => {
      const apiUrl =  domain + "/api/Employee";
      try {
          const response = await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
          }})
              return response.data;
      } catch (error) {
          console.error('Error fetching data:', error);
          return [];
      }
  }, []); */

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/Employee/active";

    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      // const employeeAllData = await fetchDataAllData();
      setEmployeesInfo(response.data);
      setAllEmployeesBasicInfo(response.data);
      setEmployees(response.data);
      setFilterData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, []);

  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeeId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );

        break;
    }

    setEmployees(res);
  };

  useEffect(() => {
    let classifiedData = allEmployeesBasicInfo;
    let classificiationFilter = classificationFilterForAdminHRHead;

    setCurrentClassificationFilter(classificiationFilter);

    if (classificiationFilter !== "0" && classificiationFilter !== "All") {
      const _classified = allEmployeesBasicInfo.filter(employee => {
        const foundEmployee = employeesInfo.find(_employee => _employee.employeeId === employee.employeeId);

        if (foundEmployee.employeeInformation && foundEmployee.employeeInformation.classificationId) {
          return foundEmployee.employeeInformation.classificationId.toString() === classificiationFilter;
        }
        return false;
      });

      classifiedData = _classified;
    }

    if (classificiationFilter !== currentClassificationFilter) {
      setEmployees(classifiedData);
      setFilterData(classifiedData);
    }
  }, [
    classificationFilterForAdminHRHead,
    currentClassificationFilter,
    employees,
    employeesInfo,
    allEmployeesBasicInfo,
  ])

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by name")
        break;
      case 1:
        setSearchPlaceholder("Search by id")
        break;
      default:
        setSearchPlaceholder("Search by name")
        break;
    }
    fetchData();
  }, [fetchData, filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="transaction-body">
                <div className='filters-payroll'>
                  <span>Filter</span>
                  <div className="payroll-item-holder info-item-holder row" style={{ padding: "0 10px 20px 10px", justifyContent: "normal" }}>
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Filter</div>
                      <div className="info-item-input">
                        <EmployeeFilter setFilterDataIndex={setFilterDataIndex} />
                      </div>
                    </div>
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Classification Type</div>
                      <div className="info-item-input">
                        <ClassificationIdSelectWithAll1 classificationId={classificationFilterForAdminHRHead} setClassificationId={setClassificationFilterForAdminHRHead} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="transaction-body-top row">
                  {CreateSearchBarWithPlaceHolder("",
                    "transaction-search row",
                    "transaction-search-icon",
                    "transaction-search-input",
                    (e) => handleFilter(e.target.value),
                    searchPlaceholder,
                    SearchIcon)}
                </div>
              </div>
              <div className="select-employee-table">
                <CreateTableForEmployeeSelect
                  dataList={employees}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedEmployee={setSelectedEmployee}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
                {employees.length > 0 ? (
                  <div></div>
                )
                  :
                  (
                    <div>
                      {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                          <img src={loadingSpinner} alt="Loading..." />
                        </div>
                      ) : (
                        <div> {/*<p>No records to display</p>*/}</div>
                      )
                      }
                    </div>
                  )}
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}>
              <button id="add-family"
                className="save row"
                onClick={handleProceed}>
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

function EmployeeFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange} style={{ color: "rgb(104, 104, 104)" }}>
      <option value="All">All</option>
      <option value="EmployeeId">Employee Id</option>
    </select>
  );
};

function ClassificationIdSelectWithAll1({ classificationId, setClassificationId, setActiveRowIds, setSelectedDTR, user }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setClassificationId(event.target.value);

    if (setActiveRowIds && setSelectedDTR) {
      setActiveRowIds([]);
      setSelectedDTR([]);
    }
  };

  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const apiUrl = domain + `/api/Classification/active/username/${user.username}`;

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [user])

  useEffect(() => {
    fetchData();
    if (classificationId !== "" && classificationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [classificationId, fetchData]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose classification</option>
        {data.length > 0 && <option value="0">All</option>}
        {data.map((classificationId) => (
          SetClassificationId(classificationId)
        ))}
      </select>
    </div>
  );
};
function SetClassificationId(classificationId) {
  return (
    <option value={classificationId.id}>{
      classificationId.description}
    </option>
  )
}